import React, { useEffect, useState, useContext } from 'react';
import { Card, Table, Space, Row, Col } from 'antd';
import { leagueCols, seasonCols, playerCols, generateLeagueCols, generateSeasonCols } from '../utils/DataUtils';
import AddSeason from '../components/AddSeason';
import AddStageParticipant from '../components/AddStageParticipant';
import AddLeague from '../components/AddLeague';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { MeContext } from '../context';
import { motion } from 'motion/react';
import { useTranslation, Trans } from 'react-i18next';


function Dashboard(props) {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [players, setPlayers] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const me = useContext(MeContext);
  const { t } = useTranslation();

  useEffect(() => {
      const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
      setIsAdmin(isAd);
      fetch(api.players().list().href)
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setPlayers(result.payLoad);
        },
        (error) => {
          setIsLoaded(true);
          setError(error); 
        }
      )
      fetch(api.seasons().list().href, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + Setting.getToken(),
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setSeasons(result.payLoad);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
      fetch(api.leagues().list().href, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + Setting.getToken(),
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          let fltrRes = result.payLoad.filter(function( obj ) {
            return obj.leagueName !== 'LPI';
          });
          setLeagues(fltrRes);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [props, me])

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
      <h1>
        Dashboard
      </h1>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ 'display': 'inline-flex' }}>
          <Card title={t('leagues.title')} style={{ 'width': '100%' }}>
            <Table
              columns={generateLeagueCols(t)} 
              dataSource={leagues} 
              pagination={true} 
              loading={!isLoaded}
              size="small"
            />
            { Setting.isLoggedIn() && isAdmin && 
              <AddLeague />
            }
          </Card>
        </Col>
      </Row>
      <Row gutter={16} type="flex">
        <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
          <Card title="Seasons" style={{ 'width': '100%' }}>
            <Table
              columns={generateSeasonCols(t)} 
              dataSource={seasons} 
              pagination={true} 
              loading={!isLoaded}
            />
            { Setting.isLoggedIn() && isAdmin &&
              <AddSeason />
            }
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12} style={{ 'display': 'inline-flex' }}>
          <Card title="Players" style={{ 'width': '100%' }}>
            <Table
                columns={playerCols} 
                dataSource={players} 
                pagination={true} 
                loading={!isLoaded}
            />
            { Setting.isLoggedIn() && isAdmin &&
              <AddStageParticipant />
            }
          </Card>
        </Col>
      </Row>
      {/*
      <p>
        <b>Props keys:</b> {JSON.stringify(Object.keys(props))}
      </p>
      <p>
        <b>Props:</b>
      </p>
      <pre style={{ width: '100%' }}>{JSON.stringify(props, null, 2)}</pre>
      */}
    </motion.div>
  );
}

export default Dashboard;